import { useEffect, useState } from 'react';

interface VersionData {
	version: string;
}

const useVersionCheck = () => {
	const [showModal, setShowModal] = useState<boolean>(false);

	useEffect(() => {
		const checkVersion = async () => {
			try {
				const res = await fetch('/version.json?ts=' + Date.now(), {
					cache: 'no-store'
				});
				const data: VersionData = await res.json();

				const current = localStorage.getItem('app_version');

				if (!current) {
					localStorage.setItem('app_version', data.version);

					return;
				}

				if (current !== data.version) {
					setShowModal(true); // activa modal bloqueante
				}
			} catch (err) {
				console.error('Error checking version:', err);
			}
		};

		checkVersion();
		const interval = setInterval(checkVersion, 30000);

		return () => clearInterval(interval);
	}, []);

	const forceUpdate = () => {
		const reload = async () => {
			const res = await fetch('/version.json', { cache: 'no-store' });
			const data: VersionData = await res.json();
			localStorage.setItem('app_version', data.version);
			window.location.reload();
		};
		reload();
	};

	return { showModal, forceUpdate };
};

export default useVersionCheck;
